import { useQuery } from "@tanstack/react-query";

import { api } from "../api/rest";
import type { TapeStats } from "../api/types";

/**
 * Счётчик объёма ленты по рынку.
 *
 * Опрос REST, а не сокет, и по той же причине, что у индекса (MarketOverview): это
 * СОСТОЯНИЕ («сколько прошло по рынку»), а не поток, где важен порядок. Заводить
 * ради него тип сообщения в сокете значило бы трогать контракт раздачи, чтобы
 * показать справочное число.
 *
 * Считать итог в браузере по ленте нельзя, и это главная причина, по которой
 * счётчик серверный: стор ленты держит тысячу последних сделок НА ВСЮ ВКЛАДКУ по
 * всем рынкам, а панель рынка режет ещё до ста пятидесяти. За окно активной
 * пятиминутки этот буфер вытесняется несколько раз, и сумма по нему отвечала бы на
 * вопрос «сколько прошло за последние минуты», выглядя ответом на «сколько прошло
 * за окно».
 */
export function tapeStatsKey(conditionID: string | undefined) {
  return ["tape-stats", conditionID ?? ""] as const;
}

/**
 * Раз в две секунды.
 *
 * Не раз в секунду, как индекс: трейдер переписывает ключ секундным таймером, а
 * число здесь читают глазами и сравнивают с чужим, которое обновляется минутами.
 */
const POLL_MS = 2000;

export function useTapeStats(conditionID: string | undefined) {
  return useQuery<TapeStats>({
    queryKey: tapeStatsKey(conditionID),
    queryFn: () => api.tape(conditionID ?? "").then((r) => r.tape),
    enabled: Boolean(conditionID),
    refetchInterval: POLL_MS,
    // В фоновой вкладке не опрашиваем: счётчик существует для сверки глазами, и
    // считать его для окна, на которое никто не смотрит, — круг ни за чем. То же
    // решение, что у позиций, и по той же причине.
    refetchIntervalInBackground: false,
  });
}
